import { BladeBaseProps, GenericBlade } from '@commblades/commblades';

const SubLoanPurpose = ({ isFocusedBlade }: BladeBaseProps) => (
    <GenericBlade
        id="sub-loanpurpose"
        confirmButtonVariant="default"
        isFocusedBlade={isFocusedBlade}
        disableReset
    />
);

export default SubLoanPurpose;
